import * as React from "react";
import { CloseButton } from "../CloseButton";
import { CloseButtonWrapper } from "./components/CloseButtonWrapper";
import { Wrapper } from "./components/Wrapper";

export interface ISettingsWindowDesktop {
  children?: any;
  onClose?: () => void;
  isOpen?: boolean;
}

export interface ISettingsWindowDesktopCloseButton {
  onClose?: () => void;
}

export const SettingsWindowDesktop = (props: ISettingsWindowDesktop) => {
  const { children, onClose } = props;

  return (
    <Wrapper {...props}>
      {onClose && <SettingsWindowDesktopCloseButton onClose={onClose} />}
      {children}
    </Wrapper>
  );
};

export const SettingsWindowDesktopCloseButton = (
  props: ISettingsWindowDesktopCloseButton
) => (
  <CloseButtonWrapper>
    <CloseButton onClick={props.onClose} />
  </CloseButtonWrapper>
);
